module.exports = __webpack_public_path__ + "static/media/wines-pos.bdbd6988.jpg";